import React, { useState, useRef } from "react";
import { Camera } from "react-camera-pro";
import Swal from "sweetalert2";
import * as faceapi from "face-api.js";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCamera,
  faArrowLeft,
  faCameraRotate,
} from "@fortawesome/free-solid-svg-icons";

const CameraView = ({ closeModal, setToggleCapture, index }) => {
  const camera = useRef(null);
  const [facingMode, setFacingMode] = useState("environment");

  const handleCapture = async () => {
    try {
      const photo = camera.current?.takePhoto();

      if (!photo) {
        Swal.fire({
          icon: "error",
          title: "Fehler",
          text: "Foto konnte nicht aufgenommen werden. Bitte versuchen Sie es erneut.",
          allowOutsideClick: false,
        });
        return;
      }

      Swal.fire({
        title: "Bild wird verarbeitet...",
        html: "Bitte warten",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      const processedPhoto = await detectAndBlurFaces(photo);
      await storeImage(processedPhoto);
      Swal.close();

      setToggleCapture(true);
      closeModal();
    } catch (error) {
      alert(
        "Fehler beim Erfassen eines Fotos. Bitte stellen Sie sicher, dass die Kamera zugänglich ist."
      );
    }
  };

  const detectAndBlurFaces = async (imageData) => {
    const img = new Image();
    img.src = imageData;
    await new Promise((resolve) => (img.onload = resolve));

    await Promise.all([
      faceapi.nets.ssdMobilenetv1.loadFromUri("/models"),
      faceapi.nets.faceLandmark68Net.loadFromUri("/models"),
      faceapi.nets.faceRecognitionNet.loadFromUri("/models"),
    ]);

    const detections = await faceapi
      .detectAllFaces(img, new faceapi.SsdMobilenetv1Options())
      .withFaceLandmarks();

    const canvas = document.createElement("canvas");
    canvas.width = img.width;
    canvas.height = img.height;
    const context = canvas.getContext("2d");

    context.drawImage(img, 0, 0, canvas.width, canvas.height);

    detections.forEach((face) => {
      const { x, y, width, height } = face.detection.box;

      const centerX = x + width / 2;
      const centerY = y + height / 2;
      const radiusX = width / 2;
      const radiusY = height / 2;
      const rotation = 0;
      const startAngle = 0;
      const endAngle = 2 * Math.PI;

      context.filter = "blur(10px)";
      context.beginPath();
      context.ellipse(
        centerX,
        centerY,
        radiusX,
        radiusY,
        rotation,
        startAngle,
        endAngle
      );
      context.closePath();
      context.fill();

      context.fillStyle = "rgba(0, 0, 0, 1)";
      context.beginPath();
      context.ellipse(
        centerX,
        centerY,
        radiusX,
        radiusY,
        rotation,
        startAngle,
        endAngle
      );
      context.fill();
    });

    context.filter = "none";

    return canvas.toDataURL("image/jpeg");
  };

  const storeImage = async (blurredImageUri) => {
    let photos = JSON.parse(localStorage.getItem(`photos${index}`) || "[]");
    photos.push({ description: "", decoded_image: blurredImageUri });
    localStorage.setItem(`photos${index}`, JSON.stringify(photos));
  };

  return (
    <div
      className="row"
      style={{
        height: "80vh",
        alignItems: "flex-end",
        justifyContent: "center",
      }}
    >
      <Camera ref={camera} facingMode={facingMode} />
      <div
        className="button-group"
        style={{
          position: "relative",
          bottom: 100,
          width: "100%",
        }}
      >
        <button
          style={{ marginRight: 10 }}
          className="btn btn-outline-info"
          onClick={closeModal}
        >
          <FontAwesomeIcon icon={faArrowLeft} /> Zurück
        </button>
        <button
          style={{ marginRight: 10 }}
          className="btn btn-primary"
          onClick={handleCapture}
        >
          <FontAwesomeIcon icon={faCamera} /> Klicken
        </button>
        <button
          className="btn btn-outline-light"
          onClick={() => camera.current.switchCamera()}
        >
          <FontAwesomeIcon icon={faCameraRotate} /> Kamera wechseln
        </button>
      </div>
    </div>
  );
};

export default CameraView;
